var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-card",
    {
      staticClass: "app-card pa-4",
      attrs: {
        text: "",
        height: "100%"
      }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "justify-center pt-0"
        },
        [_c("h2", [_vm._v("Warranty")])]
      ),
      _c(
        "v-card-text",
        {
          staticClass: "pt-0"
        },
        [
          _c(
            "v-icon",
            {
              staticClass: "centered-icon pb-3",
              attrs: {
                size: "62",
                color: "green"
              }
            },
            [_vm._v("mdi-shield-half-full")]
          ),
          _c(
            "p",
            {
              staticClass: "text-center"
            },
            [_vm._v(" Your site is covered by warranty. ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }